module.exports = __webpack_public_path__ + "img/faq.1c9243f.png";